export default function TreeLevelConnectorStackSize() {
  this.parentsStackSize = 0; /* number of overlapping horiontal connection lines between partners in level */
};